import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import { makeid } from "../utils/pageactions";

export default function Text({ value, onChange }) {
  const [_value, setValue] = useState("");
  const [height, setHeight] = useState(18);
  const [id, setId] = useState("");

  useEffect(() => {
    if (value) {
      setValue(value);
    }
  }, [value]);

  useEffect(() => {
    setId(makeid(16));
  }, []);

  const handleChange = (e) => {
    setValue(e.target.value);
    setHeight("auto");
    const text = document.getElementById(id);
    text.style.height = "auto";
    text.style.height = text.scrollHeight + "px";
  };

  return (
    <div style={{ width: "100%" }}>
      <textarea
        id={id}
        className={styles.textarea}
        rows="1"
        onBlur={() => onChange(_value)}
        value={_value}
        className={styles.textarea}
        style={{ height: 32 }}
        onChange={handleChange}
      />
    </div>
  );
}
